<template>
    <v-img ref="avatar" :src="userAvatar"></v-img>
</template>

<script>

import awsS3Helper from '@/helpers/aws-s3'

export default {
    data() {
        return {}
    },   
    methods: {
        refreshAvatar() {
            this.$refs.avatar.src = this.$store.state.avatar ?  
                                    this.$store.state.avatar : 
                                    awsS3Helper.getProfileAvatarUrl(this.$store.state.userId)
        }
    },
    computed: {
        userAvatar() {
            return this.$store.state.avatar ?  
                this.$store.state.avatar : 
                awsS3Helper.getProfileAvatarUrl(this.$store.state.userId)
        },
    },
    mounted() {
        this.$root.$on('updateUserAvatar', (data) => {
            if (data=='updateUserAvatarHandler') this.refreshAvatar()
        })
    },
    beforeDestroy() {
        this.$root.$off('updateUserAvatar')
    },
}
</script>